import React from 'react';
import { StarFilled } from '@ant-design/icons';

export default function AchievementHeader({ completed, total, points = 0 }) {
  const progress = total ? (completed / total) * 100 : 0;

  return (
    <div className="ach-header">
      <div className="ach-header__top">
        <div>
          <h2 className="ach-header__heading">Achievements</h2>
          <div className="ach-header__sub">Unlock badges by completing trading milestones.</div>
        </div>
        <div className="ach-points">
          <StarFilled /> {points} pts
        </div>
      </div>

      <div className="ach-header__row">
        <span className="ach-header__label">Progress</span>
        <span className="ach-header__count">{completed}/{total}</span>
      </div>

      <div className="ach-bar"><div className="ach-bar__fill" style={{ width: `${progress}%` }} /></div>

      <div className="ach-header__foot">{total - completed} achievements remaining</div>
    </div>
  );
}